import { CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js'
import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import { useRecoilValue } from 'recoil'

import { paramsState } from '@/store/room'
import { Network } from '@/utils/rtc/agora'

import { rtcClient } from '../..'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

export const options = {
  responsive: true,
  scales: {
    y: {
      // 自动调整最小最大值
      min: 0, // 比最小值稍小
      max: 6, // 比最大值稍大
      // 反转Y轴(1=最好在顶部)
      reverse: true,
      maintainAspectRatio: false, // 关闭固定宽高比
      beginAtZero: false,
      // 自定义刻度间隔
      ticks: {
        stepSize: 1, // 每1单位一个刻度
        // 自定义刻度标签显示
        callback: function (value: string | number) {
          // 将数值映射为文字描述
          const qualityLabels: { [key: string]: string } = {
            0: '极好',
            1: '较好',
            2: '良好',
            3: '中等',
            4: '较差',
            5: '极差',
            6: '不可用'
          }
          return qualityLabels[value] || value
        }
      }
      // Y轴标题
      // title: {
      //   display: true,
      //   text: '网络质量等级'
      // }
    }
  },
  plugins: {
    legend: {
      position: 'top' as const
    }
    // title: {
    //   display: true,
    //   text: '网络质量'
    // }
  }
}

interface NetData {
  label: string
  data: number[]
  borderColor: string
  backgroundColor: string
}

export default function Index() {
  const params = useRecoilValue(paramsState)
  const [data, setData] = useState<NetData[]>([])
  const [data1, setData1] = useState<NetData[]>([])
  const [labels, setLabels] = useState<string[]>([])
  useEffect(() => {
    rtcClient.on('network-quality', networkQuality)
    return () => {
      rtcClient.removeListener('network-quality', networkQuality)
    }
  }, [])

  const networkQuality = useCallback((network: Network) => {
    const local = network.local
    const { mainTeacherId, justTeacherId, viceTeacherId } = params
    // 过滤network.remote的key只等于mainTeacherId, justTeacherId, viceTeacherId
    const remoteKey = Object.keys(network.remote).filter((key) => {
      return [mainTeacherId, justTeacherId, viceTeacherId].includes(key)
    })
    const remote = remoteKey.reduce(
      (acc, key) => {
        acc[key] = network.remote[key]
        return acc
      },
      {} as Network['remote']
    )

    setLabels((v) => [...v, dayjs().format('HH:mm:ss')].slice(-10))
    setData((v) => {
      const localDataUp = {
        label: '本地上行',
        data: [...(v[0]?.data || []), local.uplinkNetworkQuality].slice(-10),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)'
      }
      const localDataDown = {
        label: '本地下行',
        data: [...(v[1]?.data || []), local.downlinkNetworkQuality].slice(-10),
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)'
      }
      return [localDataUp, localDataDown]
    })
    setData1((v) => {
      const remoteDataUp = Object.keys(remote).map((key) => {
        return {
          label: '老师上行' + key,
          data: [...(v.find((item) => item.label === '老师上行' + key)?.data || []), remote[key].uplinkNetworkQuality].slice(-10),
          borderColor: 'rgb(53, 162, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)'
        }
      })
      const remoteDataDown = Object.keys(remote).map((key) => {
        return {
          label: '老师下行' + key,
          data: [...(v.find((item) => item.label === '老师下行' + key)?.data || []), remote[key].downlinkNetworkQuality].slice(-10),
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)'
        }
      })
      return [...remoteDataUp, ...remoteDataDown]
    })
  }, [])

  return (
    <>
      <Line
        options={options}
        data={{
          labels,
          datasets: data
        }}
      />
      <Line
        options={options}
        data={{
          labels,
          datasets: data1
        }}
      />
    </>
  )
}
